/**
 * @file ModalSelect
 */
'use strict'

/**
 * @classname ModalSelect
 * @classdesc モーダルで検索条件が押された時に呼び出し元のボタンをアクティブにする
 */
export default class ModalSelect {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ModalSelect.constructor')
		this._$e = $e
		const modalId = this._$e.parents('.modal--detail-select').attr('id')
		this._$parentBtn = $(`[data-target="#${modalId}"]`)
		$e.on('click', () => this.onClick())

	}

	/**
	 * モーダルクローズ
	 *
	 * @memberof ModalSelect
	 * @return {undefined}
	 */
	onClick() {
		console.log('ModalSelect.onClick')

		const isActive = this._$e.find('.input-checkbox-btn__input').prop("checked")
		//const activeButs = this._$e.siblings('.input-checkbox-btn').find("input[type='checkbox']").filter(":checked")
		const $allBtn = this._$e.siblings('.input-checkbox-btn').find("input[type='checkbox']")


		const activeBtns= this._$e.closest('.modal-body').find('input:checked')


		//モーダルの検索条件が一つ以上選択されている時、呼び出し元をactive&selectedにする
		if(activeBtns.length > 0 || isActive){
			this._$parentBtn.addClass('active')
			this._$parentBtn.prop('checked', true)
		}else {
			this._$parentBtn.removeClass('active')
			this._$parentBtn.prop('checked', false)
		}

		//「全て」が選択されたら、他の選択肢のチェックを外す
		if(this._$e.is(':first-child')){
			//disabledであればリターン
			if(this._$e.find('input').prop('disabled')) return
			$allBtn.each(function() {
				$(this).prop('checked', false);
			});
		}else {
			$allBtn.eq(0).prop('checked', false);
		}
	}
}
